import React from 'react';

import {logError} from '../../util/logger';

export default class ErrorBoundary extends React.Component {
    state = {hasError: false};

    static getDerivedStateFromError() {
        return {hasError: true};
    }

    componentDidCatch(error, errorInfo) {
        logError(error, {
            type: 'react-render-error',
            componentStack: errorInfo && errorInfo.componentStack
        });
    }

    render() {
        if (this.state.hasError) {
            return (
                <main role="alert" style={{padding: '2rem', textAlign: 'center'}}>
                    <h1>Something went wrong</h1>
                    <p>The issue has been reported. Please refresh the page and try again.</p>
                    <button type="button" onClick={() => window.location.reload()}>
                        Refresh
                    </button>
                </main>
            );
        }

        return this.props.children;
    }
}
